mutation UpdateGoogleReviewOnLandingpage($input: UpdateGoogleReviewOnLandingpageInput!) {
  updateGoogleReviewOnLandingpage(input: $input) {
    company {
      showGoogleReviewOnLandingpage
    }
  }
}
